export const addKeyboardRefsNavigationMixin = {
  methods: {
    addKeyboardRefsNavigation (tableId) {
      document.removeEventListener('keydown', this.recursiveKeyDownListener, false)
      clearInterval(this.keyDownListenerInterval)
      this.keyDownListener = (event) => {
        if (this.items && (this.items.length > 0)) {

          if (event.keyCode === 40) {
            if ((this.keyPressCounter >= -1) && (this.keyPressCounter < (this.items.length - 1))) {
              this.keyPressCounter ++
            }
            if ((this.keyPressCounter > 0) && (this.keyPressCounter <= (this.items.length - 1))) {
              document.getElementById(tableId).rows[this.keyPressCounter].removeAttribute('style')
            }
            if (this.keyPressCounter <= (this.items.length - 1)) {
              document.getElementById(tableId).rows[this.keyPressCounter + 1].setAttribute('style', 'background-color: #f5f7f8')
              document.getElementById(tableId).parentNode.scrollTop += (document.getElementById(tableId).rows[this.keyPressCounter].offsetHeight)
            }
          }

          if (event.keyCode === 38) {
            if (this.keyPressCounter > 0) {
              document.getElementById(tableId).rows[this.keyPressCounter + 1].removeAttribute('style')
            }
            if ((this.keyPressCounter > -1) && (this.keyPressCounter <= (this.items.length - 1))) {
              this.keyPressCounter --
            }
            if (this.keyPressCounter >= 0) {
              document.getElementById(tableId).rows[this.keyPressCounter + 1].setAttribute('style', 'background-color: #f5f7f8')
            }
            document.getElementById(tableId).parentNode.scrollTop -= document.getElementById(tableId).rows[this.keyPressCounter + 1].offsetHeight
          }

          if (event.keyCode === 13) {
            event.preventDefault()
            if (this.keyPressCounter === -1) {
              this.keyPressCounter = 0
            }

            if (this.inputRelatedFields) {
              const item = this.items[this.keyPressCounter]
              const keys = Object.keys(item)
              for (let i = 0; i < keys.length; i++) {
                if (/^\d{2}\.\d{2}\.\d{4}$/.test(item[keys[i]])) {
                  let date = item[keys[i]].split('.')
                  date = date[2] + '-' + date[1] + '-' + date[0]
                  item[keys[i]] = date
                }
              }
              this.$emit('setRelatedFields', { relatedFields: this.inputRelatedFields, item: item, index: this.index, parent: this.parent })
            }

            if (this.select) {
              this.model = this.items[this.keyPressCounter][this.select]
              const item = this.items[this.keyPressCounter][this.select]
              if (/^\d{2}\.\d{2}\.\d{4}$/.test(item[this.select])) {
                let date = item[this.select].split('.')
                date = date[2] + '-' + date[1] + '-' + date[0]
                item[this.select] = date
              }
              this.$emit('setForm', { fieldName: this.inputId, item: item, index: this.index, parent: this.parent })
            } else {
              this.model = this.items[this.keyPressCounter][this.inputFields[0].key]
              const item = this.items[this.keyPressCounter]
              const keys = Object.keys(item)
              for (let i = 0; i < keys.length; i++) {
                if (/^\d{2}\.\d{2}\.\d{4}$/.test(item[keys[i]])) {
                  let date = item[keys[i]].split('.')
                  date = date[2] + '-' + date[1] + '-' + date[0]
                  item[keys[i]] = date
                }
              }
              this.$emit('setForm', { fieldName: this.inputId, item: item, index: this.index, parent: this.parent })
            }

            this.keyPressCounter = -1
            document.removeEventListener('keydown', this.recursiveKeyDownListener, false)
            clearInterval(this.keyDownListenerInterval)
            this.closeRef()
          }
        }
      }
      this.recursiveKeyDownListener = (event) => {
        this.keyDownListenerInterval = setInterval(this.keyDownListener(event), 100)
      }
      document.addEventListener('keydown', this.recursiveKeyDownListener, false)
      document.addEventListener('keyup', () => {
        clearInterval(this.keyDownListenerInterval)
      }, false)
    }
  }
}
